import BinderTable from 'components/features/binder-table';
import HomeLayout from 'layouts/home-layout';
import { useTranslation } from 'react-i18next';

function BinderRecords() {
  const { t } = useTranslation();

  return (
    <HomeLayout title={t('binder.binderRecords')}>
      <BinderTable />
    </HomeLayout>
  );
}

export default BinderRecords;
